let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2j8yE")).then(() => parcelRequire('lRjbR'));